import { customerList, customerDetail, creatorList, creatorDetail } from '@/api/accountManage'
import { formatDate } from '@/utils'
// $dayFormat(this.queryControl.time[0], 1)
const state = {
  form: {
    company_name: ''
  },
  pages: {
    page: 1,
    pageSize: 10,
    total: 0
  },
  tableList: [], // 客户列表
  formCreator: {
    company_id: '',
    name: '',
    time: [formatDate(new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + '01')), formatDate(new Date())],
    start_day: '',
    end_day: '',
    is_agreement: ''
  },
  pagesCreator: {
    page: 1,
    pageSize: 10,
    total: 0
  },
  creatortableList: [] // 创客列表
}
const getters = {
  form: state => state.form,
  pages: state => state.pages,
  tableList: state => state.tableList,
  formCreator: state => state.formCreator,
  pagesCreator: state => state.pagesCreator,
  creatortableList: state => state.creatortableList
}
const mutations = {
  save: (state, payload) => {
    Object.keys(payload).forEach(e => {
      if (Object.prototype.toString.call(state[e]) === '[object Object]') {
        state[e] = {
          ...state[e],
          ...payload[e]
        }
      } else {
        state[e] = payload[e]
      }
    })
  }
}
const actions = {
  // 客户列表
  partWorkListFn({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const { code, data } = await customerList(params)
      if (code === 200) {
        commit('save', {
          tableList: data.data,
          pages: {
            ...state.pages,
            total: data.total
          }
        })
        resolve()
      }
    })
  },
  // 客户详情
  customerDetail(_, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await customerDetail(params)
      if (res.code === 200) {
        res && resolve(res)
      }
    })
  },
  // 创客列表
  creatorListFn({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const { code, data } = await creatorList(params)
      if (code === 200) {
        commit('save', {
          creatortableList: data.data,
          pagesCreator: {
            ...state.pagesCreator,
            total: data.total
          }
        })
        resolve()
      }
    })
  },
  // 创客详情
  creatorDetailFn(_, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await creatorDetail(params)
      if (res.code === 200) {
        res && resolve(res)
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

